export const mcpFrCA = {
  pageTitle: "Connexions IA",
  back: "Retour",
  cardDescription:
    "Permettez à votre équipe d'utiliser ses outils d'IA avec vos données Invup.",
  statusEnabled: "Activé",
  statusOff: "Désactivé",
  statusTurningOn: "Activation en cours…",
  statusPro: "Offert avec Pro",
  statusUnavailable: "Temporairement indisponible",
  statusLoadFailed: "État indisponible",
  countNone: "Aucune connexion pour l'instant",
  count_one: "1 connexion",
  count_other: "{{count, number}} connexions",
  countPaused_one: "1 connexion suspendue",
  countPaused_other: "{{count, number}} connexions suspendues",
  connectionsLabel: "Connexions",
  countPausedValue_one: "1 suspendue",
  countPausedValue_other: "{{count, number}} suspendues",
  hintEnabled: "Compté pour l'ensemble de votre organisation.",
  hintNone:
    "Personne n'a encore connecté d'outil d'IA. Les membres se connectent à partir de leur propre profil.",
  hintOffManager:
    "Les membres voient leurs connexions comme désactivées par votre organisation. Réactivez ce paramètre pour les rétablir.",
  hintOffViewer:
    "Les membres voient leurs connexions comme désactivées par votre organisation. Demandez à une personne qui gère les intégrations de réactiver ce paramètre.",
  switchLabel: "Autoriser les connexions IA",
  switchDescription:
    "Lorsque ce paramètre est désactivé, les outils d'IA ne peuvent pas accéder aux données de votre organisation. Les connexions sont suspendues, et non supprimées.",
  readOnlyNote:
    "Seules les personnes qui gèrent les intégrations peuvent modifier ce paramètre.",
  turnedOffSuccess: "Connexions IA désactivées avec succès.",
  turnedOnSuccess:
    "Connexions IA activées avec succès. Les connexions existantes fonctionnent de nouveau.",
  turnOnError:
    "Désolé, les connexions IA n'ont pas pu être activées en raison d'une erreur de notre côté. Veuillez réessayer.",
  turnOffError:
    "Désolé, les connexions IA n'ont pas pu être désactivées en raison d'une erreur de notre côté. Veuillez réessayer.",
  forbiddenError:
    "Vous n'avez plus la permission de modifier ce paramètre. Rechargez la page pour voir vos accès actuels.",
  loadError:
    "Désolé, l'état des connexions IA n'a pas pu être chargé en raison d'une erreur de notre côté. Veuillez réessayer.",
  retry: "Réessayer",
  upgradeTitle: "Connectez vos outils d'IA à Invup",
  upgradeBody:
    "Permettez aux membres d'utiliser tout outil d'IA compatible avec MCP, comme Claude, ChatGPT ou Cursor, avec les données de votre organisation. Offert avec le forfait Pro.",
  upgradeAskOwner:
    "Renseignez-vous auprès du propriétaire de votre organisation pour passer au forfait supérieur.",
  upgradeCta: "Passer à Pro",
  unavailableTitle: "Les connexions IA sont temporairement indisponibles",
  unavailableBody:
    "Invup a suspendu les connexions IA pour toutes les organisations. Votre paramètre et les connexions de vos membres sont conservés, et ils fonctionneront de nouveau dès le rétablissement du service.",
  overviewText:
    "Les connexions IA permettent aux membres d'utiliser tout outil d'IA compatible avec MCP, comme Claude, ChatGPT ou Cursor, avec vos données Invup. Chaque connexion agit avec le rôle de son membre : un outil d'IA ne peut voir et faire que ce que ce membre peut faire.",
  feature1Prefix:
    "Chaque membre connecte son outil d'IA à partir de son propre",
  profileLink: "profil",
  feature1Suffix: "et autorise l'accès une seule fois.",
  feature2:
    "Une connexion ne peut voir et faire que ce que le rôle de son membre permet.",
  feature3:
    "Désactiver les connexions les suspend toutes d'un coup. Les réactiver les rétablit, sans que personne n'ait à les autoriser de nouveau.",
  turnOffTitle: "Désactiver les connexions IA",
  turnOffBody_one:
    "1 connexion cessera de fonctionner immédiatement, et son membre la verra comme désactivée par votre organisation. Rien n'est supprimé : réactivez les connexions et elle fonctionnera de nouveau sans que personne ait à l'autoriser.",
  turnOffBody_other:
    "{{count, number}} connexions cesseront de fonctionner immédiatement, et les membres les verront comme désactivées par votre organisation. Rien n'est supprimé : réactivez les connexions et elles fonctionneront de nouveau sans que personne ait à les autoriser.",
  turnOffBodyNone:
    "Personne n'a encore connecté d'outil d'IA. Tant que ce paramètre est désactivé, les membres ne peuvent pas connecter d'outils d'IA à votre organisation. Vous pouvez le réactiver en tout temps.",
  turnOffConfirm: "Désactiver",
};
